<div class="dashboard-card clearfix">
  <div class="header clearfix">
    <h4>{{'menu.financial'|translate}}</h4>
    <jbm-dashboard-date-range-filter class="float-start ms-4"></jbm-dashboard-date-range-filter>
  </div>
  <dashboard-invoicing></dashboard-invoicing>
  <dashboard-quotations></dashboard-quotations>
  <dashboard-customers></dashboard-customers>
  <dashboard-price-agreements></dashboard-price-agreements>
</div>
